import { useState, useEffect } from "react";
import BackMethods from "../../back_component/BackMethods";
import { useNavigate, useLocation } from "react-router-dom";

export default function UsersManagementPage() {

    const location = useLocation();
    const successMessage = location.state?.successMessage;
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");

    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filterType, setFilterType] = useState("all");

    // جلب المستخدمين من السيرفر
    const fetchUsers = async () => {
        try {
            const res = await backEnd_request.get("/admin/UsersManagement");
            setUsers(res.data.users);
            setFilteredUsers(res.data.users);
        } catch (error) {
            console.log(error.response?.data || error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    // تصفية حسب الاسم أو اسم المستخدم أو نوع المستخدم
    const handleSearch = (term, type) => {
        setSearchTerm(term);
        setFilterType(type);

        let filtered = users.filter((user) => {
            if (!term.trim()) return true;

            switch (type) {
                case "username":
                    return user.username.toLowerCase().includes(term.toLowerCase());
                case "name":
                    return (
                        user.firstName?.toLowerCase().includes(term.toLowerCase()) ||
                        user.lastName?.toLowerCase().includes(term.toLowerCase())
                    );
                case "type":
                    return user.userTypeName.toLowerCase().includes(term.toLowerCase());
                default:
                    return true;
            }
        });

        setFilteredUsers(filtered);
    };

    // العمليات على المستخدمين (تعديل، حذف، تفعيل، إلغاء تفعيل)
    const handleEdit = (userId) => {
        navigate(`/admin/users-management/edit/${userId}`);
    };

    const handleDelete = async (userId) => {
        if (window.confirm("هل أنت متأكد من حذف هذا المستخدم؟")) {
            try {
                const res = await backEnd_request.delete("/admin/UsersManagement/" + userId);
                fetchUsers();
                setDeleteSuccessMessage("تم حذف المستخدم بنجاح ✅");

                // إخفاء الرسالة بعد 3 ثوانٍ
                setTimeout(() => setDeleteSuccessMessage(""), 3000);
            } catch (error) {
                console.log(error.response?.data || error);
            }
        }
    };
    const handleToggleActive = async (userId, isActive) => {
        if (window.confirm(isActive ? "هل أنت متأكد من الغاء تفعيل الحساب" : "هل أنت متأكد من تفعيل الحساب")) {
            try {
                const res = await backEnd_request.patch("/admin/UsersManagement/" + userId + "/toggle-active", { "isActive": !isActive });
                fetchUsers();
            } catch (error) {
                console.log(error.response?.data || error);
            }
        }
    };

    return (
        <div className="container py-5">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h3 className="fw-bold text-primary">إدارة المستخدمين</h3>
                <button
                    className="btn btn-success"
                    onClick={() => navigate("/admin/users-management/create")}

                >
                    <i className="bi bi-person-plus"></i> إضافة مستخدم
                </button>
            </div>
            {successMessage && (
                <div className="alert alert-success text-center fw-bold">
                    {successMessage}
                </div>
            )}

            {deleteSuccessMessage && (
                <div className="alert alert-success text-center fw-bold">
                    {deleteSuccessMessage}
                </div>
            )}
            {/* أدوات البحث */}
            <div className="card shadow-sm mb-4 p-3">
                <div className="row g-3 align-items-center">
                    <div className="col-md-4">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="اكتب هنا للبحث..."
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value, filterType)}
                        />
                    </div>
                    <div className="col-md-3">
                        <select
                            className="form-select"
                            value={filterType}
                            onChange={(e) => handleSearch(searchTerm, e.target.value)}
                        >
                            <option value="all">كل الحقول</option>
                            <option value="username">اسم المستخدم</option>
                            <option value="name">الاسم</option>
                            <option value="type">نوع المستخدم</option>
                        </select>
                    </div>
                    <div className="col-md-2">
                        <button
                            className="btn btn-outline-secondary w-100"
                            onClick={() => {
                                setSearchTerm("");
                                setFilteredUsers(users);
                            }}
                        >
                            إعادة تعيين
                        </button>
                    </div>
                </div>
            </div>

            {/* الجدول */}
            <div className="table-responsive shadow-sm">
                <table className="table table-hover align-middle text-center">
                    <thead className="table-primary">
                        <tr>
                            <th>اسم المستخدم</th>
                            <th>الاسم</th>
                            <th>نوع المستخدم</th>
                            <th>الحالة</th>
                            <th>إجراءات</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredUsers.length > 0 ? (
                            filteredUsers.map((user) => (
                                <tr key={user.userId}>
                                    <td>{user.username}</td>
                                    <td>{user.firstName + " " + user.lastName}</td>
                                    <td>
                                        <span
                                            className={`badge ${user.userTypeName === "Web"
                                                ? "bg-primary"
                                                : "bg-info"
                                                }`}
                                        >
                                            {user.userTypeName}
                                        </span>
                                    </td>
                                    <td>
                                        <span
                                            className={`badge ${user.isActive
                                                ? "bg-success"
                                                : "bg-danger"
                                                }`}
                                        >
                                            {user.isActive ? "مفعل" : "غير مفعل"}
                                        </span>
                                    </td>
                                    <td>
                                        <div className="btn-group">
                                            <button
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => handleEdit(user.userId)}
                                            >
                                                <i className="bi bi-pencil-square"></i>
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => handleDelete(user.userId)}
                                            >
                                                <i className="bi bi-trash"></i>
                                            </button>
                                            <button
                                                className={`btn btn-sm ${user.isActive
                                                    ? "btn-outline-warning"
                                                    : "btn-outline-success"
                                                    }`}
                                                onClick={() =>
                                                    handleToggleActive(
                                                        user.userId,
                                                        user.isActive
                                                    )
                                                }
                                            >
                                                {user.isActive ? (
                                                    <i className="bi bi-slash-circle"></i>
                                                ) : (
                                                    <i className="bi bi-check-circle"></i>
                                                )}
                                            </button>
                                            <button
                                                className="btn btn-sm btn-outline-secondary"
                                                onClick={() => navigate(`/admin/users-management/change-password/${user.userId}`)}
                                            >
                                                <i className="bi bi-key"></i>
                                            </button>

                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-muted py-4">
                                    لا توجد بيانات لعرضها
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

            </div>
        </div>
    );
}
